<template>
    <div class="card-method">
        <h5 class="body__medium title">{{tokens.newDesign.paymentDetails}}</h5>
        <div class="card-info">
            <BaseInput
                class="name"
                v-model="name"
                :title="tokens.newDesign.nameOnCard"
                :placeholder="tokens.newDesign.nameOnCard"
            />
            <BaseInput
                class="number"
                v-model="cardNumber"
                :title="tokens.newDesign.cardNumber"
                :placeholder="'0000 0000 0000 0000'"
                :mask="'####' + ' ####'.repeat(15)"
                :id="'info-slot-hidden-mobile'"
            >
                <template #info>
                    <div class="cards-list">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16" viewBox="0 0 25 16"
                             fill="none">
                            <g clip-path="url(#clip0_954_20151)">
                                <mask id="mask0_954_20151" style="mask-type:luminance"
                                      maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="16">
                                    <path d="M24.5 0H0.5V16H24.5V0Z" fill="white"/>
                                </mask>
                                <g mask="url(#mask0_954_20151)">
                                    <path
                                        d="M22.4574 0H2.54255C1.41448 0 0.5 0.924315 0.5 2.06452V13.9355C0.5 15.0757 1.41448 16 2.54255 16H22.4574C23.5855 16 24.5 15.0757 24.5 13.9355V2.06452C24.5 0.924315 23.5855 0 22.4574 0Z"
                                        fill="white" stroke="black" stroke-opacity="0.2"
                                        stroke-width="0.510638"/>
                                    <path
                                        d="M3.09188 5.84726C2.55761 5.55107 1.94785 5.31286 1.26611 5.14755L1.29471 5.01881H4.08992C4.4688 5.03223 4.77623 5.14746 4.87627 5.55438L5.48375 8.48174L5.66984 9.36342L7.37127 5.01881H9.20836L6.47756 11.3833H4.64037L3.09188 5.84726ZM10.5597 11.3901H8.82236L9.90902 5.01881H11.6462L10.5597 11.3901ZM16.8577 5.17457L16.6214 6.55038L16.4643 6.48272C16.1499 6.3539 15.7349 6.22516 15.1701 6.23877C14.4842 6.23877 14.1766 6.5165 14.1695 6.78766C14.1695 7.08594 14.5416 7.28251 15.1492 7.57403C16.1502 8.02816 16.6145 8.5839 16.6076 9.30919C16.5935 10.6309 15.4067 11.4851 13.5838 11.4851C12.8043 11.4782 12.0536 11.322 11.6462 11.146L11.8893 9.71575L12.118 9.81755C12.6828 10.055 13.0545 10.1565 13.7481 10.1565C14.2483 10.1565 14.7846 9.95971 14.7915 9.53288C14.7915 9.25496 14.563 9.05145 13.8908 8.73966C13.2332 8.43454 12.3539 7.92627 12.3682 7.01117C12.3756 5.77086 13.5838 4.90332 15.2994 4.90332C15.9715 4.90332 16.515 5.04566 16.8577 5.17457ZM19.1668 9.13298H20.6108C20.5394 8.81444 20.2104 7.28936 20.2104 7.28936L20.089 6.74037C20.0032 6.97757 19.8532 7.36395 19.8604 7.35035C19.8604 7.35035 19.3099 8.76696 19.1668 9.13298ZM21.3113 5.01881L22.7129 11.39H21.1043C21.1043 11.39 20.9469 10.658 20.897 10.4343H18.6664C18.6019 10.6036 18.3018 11.39 18.3018 11.39H16.4788L19.0594 5.54744C19.2382 5.13394 19.5531 5.01881 19.9675 5.01881H21.3113Z"
                                        fill="#171E6C"/>
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_954_20151">
                                    <rect width="24" height="16" fill="white" transform="translate(0.5)"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18"
                             fill="none">
                            <path
                                d="M22.5 1H2.5C1.39543 1 0.5 1.89543 0.5 3V15C0.5 16.1046 1.39543 17 2.5 17H22.5C23.6046 17 24.5 16.1046 24.5 15V3C24.5 1.89543 23.6046 1 22.5 1Z"
                                fill="white" stroke="black" stroke-opacity="0.2" stroke-width="0.5"/>
                            <path
                                d="M9.5 14C12.2614 14 14.5 11.7614 14.5 9C14.5 6.23858 12.2614 4 9.5 4C6.73858 4 4.5 6.23858 4.5 9C4.5 11.7614 6.73858 14 9.5 14Z"
                                fill="#EB001B"/>
                            <path
                                d="M15.5 14C18.2614 14 20.5 11.7614 20.5 9C20.5 6.23858 18.2614 4 15.5 4C12.7386 4 10.5 6.23858 10.5 9C10.5 11.7614 12.7386 14 15.5 14Z"
                                fill="#F79E1B"/>
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M12.5 4.99951C13.7144 5.91172 14.5 7.36406 14.5 8.99988C14.5 10.6357 13.7144 12.088 12.5 13.0002C11.2856 12.088 10.5 10.6357 10.5 8.99988C10.5 7.36406 11.2856 5.91172 12.5 4.99951Z"
                                  fill="#FF5F00"/>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16" viewBox="0 0 25 16"
                             fill="none">
                            <g clip-path="url(#clip0_954_20164)">
                                <mask id="mask0_954_20164" style="mask-type:luminance"
                                      maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="16">
                                    <path d="M24.5 0H0.5V16H24.5V0Z" fill="white"/>
                                </mask>
                                <g mask="url(#mask0_954_20164)">
                                    <path
                                        d="M22.5 0H2.5C1.39543 0 0.5 0.89543 0.5 2V14C0.5 15.1046 1.39543 16 2.5 16H22.5C23.6046 16 24.5 15.1046 24.5 14V2C24.5 0.89543 23.6046 0 22.5 0Z"
                                        fill="#016FD0"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M14.2642 13.3938V7.69238L24.4118 7.70149V9.27638L23.2389 10.5298L24.4118 11.7947V13.403H22.5392L21.544 12.3048L20.5559 13.4071L14.2642 13.3938Z"
                                          fill="#FFFFFE"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M14.9419 12.7687V8.31982H18.7142V9.34471H16.1633V10.0404H18.6533V11.0482H16.1633V11.7315H18.7142V12.7687H14.9419Z"
                                          fill="#016FD0"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M18.6954 12.7689L20.7827 10.5419L18.6953 8.32007H20.3109L21.5864 9.7301L22.8655 8.32007H24.4117V8.35507L22.3688 10.5419L24.4117 12.7057V12.7689H22.85L21.5519 11.3447L20.2671 12.7689H18.6954Z"
                                          fill="#016FD0"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M14.7374 2.63184H17.1834L18.0426 4.58269V2.63184H21.0624L21.5832 4.09341L22.1057 2.63184H24.4116V8.33323H12.2251L14.7374 2.63184Z"
                                          fill="#FFFFFE"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M15.2007 3.25146L13.2266 7.69664H14.5805L14.953 6.80647H16.9709L17.3431 7.69664H18.7306L16.7649 3.25146H15.2007ZM15.3703 5.8089L15.9623 4.39383L16.5538 5.8089H15.3703Z"
                                          fill="#016FD0"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M18.7119 7.69582V3.25073L20.615 3.25727L21.5943 5.99L22.5799 3.25073H24.4115V7.69582L23.2329 7.70625V4.6529L22.1204 7.69582H21.0446L19.9089 4.64247V7.69582H18.7119Z"
                                          fill="#016FD0"/>
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_954_20164">
                                    <rect width="24" height="16" fill="white" transform="translate(0.5)"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16" viewBox="0 0 25 16"
                             fill="none">
                            <g clip-path="url(#clip0_954_20176)">
                                <mask id="mask0_954_20176" style="mask-type:luminance"
                                      maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="16">
                                    <path d="M24.5 0H0.5V16H24.5V0Z" fill="white"/>
                                </mask>
                                <g mask="url(#mask0_954_20176)">
                                    <path
                                        d="M22.4972 15.7499H22.4994C23.4545 15.7581 24.2381 14.9773 24.25 14.0042V2.0063C24.2462 1.53569 24.0589 1.08617 23.7297 0.756802C23.4014 0.428269 22.9589 0.246149 22.4972 0.250071L2.50064 0.250062C2.04109 0.246149 1.59858 0.428269 1.27028 0.756802C0.941145 1.08617 0.753838 1.53569 0.750008 2.00426L0.75 13.9937C0.753838 14.4643 0.941145 14.9138 1.27028 15.2432C1.59858 15.5717 2.04109 15.7538 2.50277 15.7499H22.4972Z"
                                        fill="white"/>
                                    <path
                                        d="M22.4962 16.2499C22.4958 16.2499 22.4955 16.2499 22.4951 16.2499M22.4972 15.7499H22.4994C23.4545 15.7581 24.2381 14.9773 24.25 14.0042V2.0063C24.2462 1.53569 24.0589 1.08617 23.7297 0.756802C23.4014 0.428269 22.9589 0.246149 22.4972 0.250071L2.50064 0.250062C2.04109 0.246149 1.59858 0.428269 1.27028 0.756802C0.941145 1.08617 0.753838 1.53569 0.750008 2.00426L0.75 13.9937C0.753838 14.4643 0.941145 14.9138 1.27028 15.2432C1.59858 15.5717 2.04109 15.7538 2.50277 15.7499H22.4972Z"
                                        stroke="black" stroke-opacity="0.2" stroke-width="0.5"/>
                                    <path
                                        d="M13.1123 15.9999H22.4972C23.0239 16.0043 23.5309 15.7993 23.9065 15.4299C24.2821 15.0605 24.4955 14.557 24.4999 14.0303V11.6716C20.9561 13.7059 17.1127 15.1668 13.1123 15.9999Z"
                                        fill="#F27712"/>
                                    <path
                                        d="M23.6725 9.29643H22.82L21.8601 8.03023H21.769V9.29643H21.0738V6.15161H22.1C22.9028 6.15161 23.3663 6.48264 23.3663 7.0785C23.3663 7.56678 23.0766 7.88126 22.5552 7.98057L23.6725 9.29643ZM22.6463 7.10333C22.6463 6.79712 22.4145 6.63988 21.9842 6.63988H21.769V7.59161H21.9676C22.4145 7.59161 22.6463 7.42609 22.6463 7.10333ZM18.6407 6.15161H20.6104V6.68126H19.3359V7.38471H20.5607V7.92264H19.3359V8.77505H20.6104V9.30471H18.6407V6.15161ZM16.4063 9.37919L14.9001 6.14333H15.6614L16.6132 8.26195L17.5732 6.14333H18.318L16.7952 9.37919H16.4228H16.4063ZM10.1083 9.37092C9.04902 9.37092 8.22143 8.65092 8.22143 7.71574C8.22143 6.8054 9.06557 6.06885 10.1249 6.06885C10.4228 6.06885 10.6711 6.12678 10.9773 6.25919V6.98747C10.7454 6.75965 10.4334 6.63187 10.1083 6.63161C9.44626 6.63161 8.94143 7.11161 8.94143 7.71574C8.94143 8.35299 9.43798 8.80816 10.1414 8.80816C10.4559 8.80816 10.6959 8.70885 10.9773 8.46057V9.18885C10.6628 9.32126 10.398 9.37092 10.1083 9.37092ZM8.00626 8.33643C8.00626 8.94885 7.50143 9.37092 6.77315 9.37092C6.2435 9.37092 5.86281 9.18885 5.54005 8.77505L5.99522 8.38609C6.15246 8.66747 6.41729 8.80816 6.74833 8.80816C7.06281 8.80816 7.28626 8.61781 7.28626 8.36954C7.28626 8.22885 7.22005 8.12126 7.07936 8.0385C6.9251 7.96365 6.76446 7.90271 6.59936 7.85643C5.94557 7.64954 5.72212 7.42609 5.72212 6.98747C5.72212 6.47436 6.20212 6.0854 6.83109 6.0854C7.22833 6.0854 7.58419 6.20954 7.88212 6.44126L7.51798 6.85505C7.37366 6.69683 7.16938 6.60671 6.95522 6.60678C6.65729 6.60678 6.44212 6.75574 6.44212 6.95436C6.44212 7.11988 6.56626 7.21092 6.98005 7.35161C7.77453 7.59988 8.00626 7.83161 8.00626 8.34471V8.33643ZM4.58833 6.15161H5.2835V9.30471H4.58833V6.15161ZM2.35384 9.30471H1.32764V6.15161H2.35384C3.47936 6.15161 4.25729 6.79712 4.25729 7.72402C4.25729 8.19574 4.02557 8.64264 3.62005 8.94057C3.27246 9.18885 2.8835 9.30471 2.34557 9.30471H2.35384ZM3.16488 6.93781C2.93315 6.75574 2.66833 6.68954 2.21315 6.68954H2.02281V8.77505H2.21315C2.66005 8.77505 2.94143 8.6923 3.16488 8.52678C3.40488 8.32816 3.54557 8.03023 3.54557 7.72402C3.54557 7.41781 3.40488 7.12816 3.16488 6.93781Z"
                                        fill="black"/>
                                    <path
                                        d="M12.9139 6.06885C12.0036 6.06885 11.2588 6.79712 11.2588 7.69919C11.2588 8.65919 11.9705 9.37919 12.9139 9.37919C13.8408 9.37919 14.5691 8.65092 14.5691 7.72402C14.5691 6.79712 13.8491 6.06885 12.9139 6.06885Z"
                                        fill="#F27712"/>
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_954_20176">
                                    <rect width="24" height="16" fill="white" transform="translate(0.5)"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </template>
            </BaseInput>
            <BaseInput
                class="expiration"
                v-model="expiration"
                :title="tokens.newDesign.expirationDate"
                :placeholder="'12/12'"
                :mask="'##/##'"
            />
            <BaseInput
                class="code"
                v-model="cvv"
                :title="tokens.newDesign.securityCode"
                :placeholder="'123'"
                :mask="'####'"
            >
                <template #info>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16" viewBox="0 0 25 16" fill="none">
                        <g clip-path="url(#clip0_1307_23102)">
                            <path
                                d="M23.0818 15.6585H1.91818C1.31818 15.6585 0.827271 15.1468 0.827271 14.5213V1.47799C0.827271 0.852547 1.31818 0.34082 1.91818 0.34082H23.0818C23.6818 0.34082 24.1727 0.852547 24.1727 1.47799V14.5213C24.1727 15.1468 23.6818 15.6585 23.0818 15.6585Z"
                                fill="white" fill-opacity="0.5"/>
                            <path
                                d="M23.0818 16H1.91818C1.13273 16 0.5 15.3404 0.5 14.5217V1.47832C0.5 0.659559 1.13273 0 1.91818 0H23.0818C23.8673 0 24.5 0.659559 24.5 1.47832V14.5217C24.5 15.3404 23.8673 16 23.0818 16ZM1.91818 0.682303C1.49273 0.682303 1.15455 1.03483 1.15455 1.47832V14.5217C1.15455 14.9652 1.49273 15.3177 1.91818 15.3177H23.0818C23.5073 15.3177 23.8455 14.9652 23.8455 14.5217V1.47832C23.8455 1.03483 23.5073 0.682303 23.0818 0.682303H1.91818Z"
                                fill="#CACACA" fill-opacity="0.5"/>
                            <path d="M24.1273 2.71777H0.827271V5.90185H24.1273V2.71777Z" fill="#CBCBCB"/>
                            <path d="M12.7182 8.51758H2.90002V11.1331H12.7182V8.51758Z" fill="#CBCBCB"/>
                            <path
                                d="M16.2091 9.35973L15.8382 9.4507L15.74 9.05269L16.3509 8.85938H16.6673V11.0996H16.2091V9.35973Z"
                                fill="black"/>
                            <path
                                d="M17.18 10.7243L17.8891 10.1216C18.1509 9.8942 18.26 9.76911 18.26 9.58716C18.26 9.39385 18.14 9.30287 17.9763 9.30287C17.8127 9.30287 17.7036 9.39385 17.54 9.59854L17.2127 9.32562C17.42 9.02995 17.6272 8.85938 18.0091 8.85938C18.4563 8.85938 18.74 9.1323 18.74 9.54168V9.55305C18.74 9.92832 18.5545 10.1103 18.1727 10.4173L17.8236 10.7016H18.7509V11.1223H17.1691V10.7243H17.18Z"
                                fill="black"/>
                            <path
                                d="M19.1218 10.7582L19.4491 10.4398C19.5909 10.6103 19.7436 10.7127 19.9618 10.7127C20.1364 10.7127 20.2673 10.6103 20.2673 10.4398V10.4284C20.2673 10.2464 20.1146 10.1441 19.8527 10.1441H19.6564L19.58 9.83706L20.0927 9.30259H19.2527V8.88184H20.6927V9.24573L20.1473 9.7802C20.4418 9.82569 20.7255 9.98489 20.7255 10.4056V10.417C20.7255 10.8378 20.4309 11.1448 19.9509 11.1448C19.5691 11.1448 19.3073 10.9856 19.1218 10.7582Z"
                                fill="black"/>
                            <path
                                d="M21.9909 12.1562H14.5182V7.83496H21.9909V12.1562ZM14.7364 11.9288H21.7727V8.0624H14.7364V11.9288Z"
                                fill="#CACACA"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_1307_23102">
                                <rect width="24" height="16" fill="white" transform="translate(0.5)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </template>
            </BaseInput>
        </div>
        <div class="order-details">
            <h5 class="title__medium title">{{tokens.newDesign.otherDetails}}</h5>
            <div class="order-info">
                <div class="currencies" @click="toggler()">
                    <BaseSelectBox
                        v-model="currency"
                        :placeholder="currency"
                        :state="state"
                        :hide-arrow="true"
                        :placement="'full'"
                        :title="tokens.orderMenu.currency"
                        :options="currencies.map(item => ({
                            key: item,
                            title: item
                        }))"
                        @update="changeCurrency"
                    >
                        <template #placeholder>
                            <div class="placeholder">
                                <div class="icon">
                                    <img :src="staticBase+`currencies/${currency ? currency : 'USD'}.png`" alt="">
                                    <p class="body__large">{{currency}}</p>
                                </div>
                                <span class="material-symbols-outlined">{{state ? 'arrow_drop_up' : 'arrow_drop_down'}}</span>
                            </div>
                        </template>
                        <template #option="{option}">
                            <img :src="staticBase+`currencies/${option.key ? option.key : 'USD'}.png`" alt="">
                            <div class="name">{{ option.title }}</div>
                        </template>
                    </BaseSelectBox>
                </div>
                <BaseInput class="amount" v-model="amount" :type="'number'" :title="tokens.newDesign.amount" :placeholder="'0.00'">
                    <template #icon>
                        <p class="body__large">{{ currencySign(currency) }}</p>
                    </template>
                </BaseInput>
            </div>
        </div>
        <div class="action">
            <p class="info body__extrasmall">*{{tokens.newDesign.depositText}}</p>
            <BaseButton
                :button-text="tokens.newDesign.confirmDeposit"
                :button-style="'filled-tertiary'"
                :disabled="!amount || disabledButton"
                @click.native="makeDeposit"
            />
        </div>
    </div>
</template>

<script>
import BaseInput from "@/new-design/shared/ui/Inputs/BaseInput.vue"
import BaseSelectBox from "@/new-design/shared/ui/Inputs/BaseSelectBox.vue"
import toggler from "@/new-design/shared/mixins/toggler"
import {currencySign} from "@/common/helpers"
import BaseButton from "@/new-design/shared/ui/buttons/BaseButton.vue"
import {mapGetters} from "vuex";

export default {
    name: "CardMethod",
    components: {BaseButton, BaseSelectBox, BaseInput},
    mixins: [toggler],
    mounted() {
        this.init()
    },
    props: {
        currencies: {
            type: Array,
            default: () => []
        },
        method: {
            type: String
        },
        disabledButton: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            name: '',
            cardNumber: '',
            expiration: '',
            cvv: '',
            amount: null,
            selectedCurrency: '',
        }
    },
    methods: {
        currencySign,
        init() {
            this.name = ''
            this.cardNumber = ''
            this.expiration = ''
            this.cvv = ''
            this.amount = null
        },
        changeCurrency(currency) {
            this.currency = currency
        },
        makeDeposit() {
            this.$emit('update', {
                info: {
                    name: this.name,
                    cardNumber: this.cardNumber,
                    expiration: this.expiration,
                    month: this.expiration.slice(0, 2),
                    year: this.expiration.slice(3, 5),
                    cvv: this.cvv,
                    amount: this.amount,
                    currency: this.currency
                }
            })
        }
    },
    computed: {
        ...mapGetters(['tokens','staticBase']),
        currency: {
            get() {
                return this.selectedCurrency || (this.currencies.length ? this.currencies[0] : '')
            },
            set(value) {
                this.selectedCurrency = value
            }
        },
    },
    watch: {
        'method': {
            handler() {
                this.init();
                this.selectedCurrency = ""
            }
        }
    }
}
</script>

<style scoped>
.title {
    color: var(--System-OnSurface);
    padding: 16px 0;
}

.card-info {
    padding: 16px 0 25px;
    border-bottom: 1px solid var(--System-Surface5);
    display: grid;
    gap: 20px 12px;
}

.name {
    grid-area: 1/2 span;
}

.number {
    grid-area: 2/2 span;
}

.expiration {
    grid-area: 3/1;
}

.code {
    grid-area: 3/2;
}

.cards-list {
    display: flex;
    align-items: center;
    gap: 4px;
}

.order-details {
    padding: 16px 0;
}

.order-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.currencies {
    position: relative;
    cursor: pointer;
}

img {
    width: 20px;
    height: 20px;
    object-fit: cover;
}

.action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
}

.info {
    color: var(--System-Outline);
}

.placeholder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 8px 8px 8px;
    outline: none;
    height: 100%;
    background: transparent;
    color: var(--System-OnSurface);
    width: 100%;
    transition: all .3s ease;
    border-radius: 4px;
    border: 1px solid var(--System-Outline);
}

.icon {
    display: flex;
    align-items: center;
    gap: 4px;
}

.info {
    text-align: left;
}

@media (max-width: 468px) {
    .title {
        text-align: left;
    }

    .order-info {
        grid-template-columns: 1fr;
    }

    .action {
        flex-direction: column;
        gap: 16px;
    }

    .action button {
        display: inline-block;
        margin: 0 0 0 auto;
    }
}
</style>
